<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (screen.width < 1080) {
      var width = screen.width // 通过window.screen.width获取屏幕的宽度
      var offWidth = width / 21.60 // 这里用宽度/30表示1rem取得的px
      document.getElementsByTagName('html')[0].style.fontSize = offWidth + 'px' // 把rem的值复制给顶级标签html的font-size
    }
  }
}
</script>

<style>
  @import './assets/css/common.css';
  @import './assets/css/weui.min.css';
#app {
  font-family: 'MicrosoftYaHei';
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue